export default __webpack_public_path__ + "static/media/sanmat5.c4b4e845.jpg";